import { Box, Checkbox, FormControlLabel, Switch, Typography } from '@mui/material';

import { RatingBadgeChip, Section, SectionCard, SectionHeader } from '@/components/common';
import { RichTextReadOnly } from '@/components/common/RichTextEditor/RichTextReadOnly';
import { readOnlySectionVariant } from '@/auth/sectionReadOnlyStyle';
import type { AppraisalDetailResponse } from '@/api/types/appraisal.types';
import type { RecordAccess } from '@/auth/permissions.types';

interface NotesActionsForCollatorSectionProps {
  appraisalDetail: AppraisalDetailResponse;
  permissions: RecordAccess;
}

export function NotesActionsForCollatorSection({
  appraisalDetail,
  permissions,
}: NotesActionsForCollatorSectionProps) {
  const readOnlyVariant = readOnlySectionVariant('notesActionsForCollator', permissions.role);

  return (
    <Section>
      <SectionHeader>NOTES &amp; ACTIONS FOR COLLATOR</SectionHeader>

      <SectionCard>
        <RichTextReadOnly content={appraisalDetail.notesForCollator ?? ''} variant={readOnlyVariant} />

        <Box sx={{ display: 'flex', gap: 6, mt: 3, flexWrap: 'wrap' }}>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              TC Rating
            </Typography>
            <RatingBadgeChip code={appraisalDetail.tcDecisionRating} />
          </Box>

          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              TC Decision
            </Typography>
            <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={appraisalDetail.tcDecisionPromote}
                    disabled
                    inputProps={{ 'aria-label': 'Promote' }}
                  />
                }
                label="Promote"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={appraisalDetail.tcDecisionHoldAtGrade}
                    disabled
                    inputProps={{ 'aria-label': 'Hold at Grade' }}
                  />
                }
                label="Hold at Grade"
              />
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', gap: 3, mt: 2, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          <FormControlLabel
            control={
              <Switch
                checked={appraisalDetail.isFinalStaffingReview}
                disabled
                inputProps={{ 'aria-label': 'Final Staffing Review' }}
              />
            }
            label="Final Staffing Review"
          />
          <FormControlLabel
            control={
              <Switch
                checked={appraisalDetail.isAwaitingHrGuidance}
                disabled
                inputProps={{ 'aria-label': 'Awaiting HR Guidance' }}
              />
            }
            label="Awaiting HR Guidance"
          />
        </Box>
      </SectionCard>
    </Section>
  );
}
